export default {
  placeholderApiUrl: 'https://coffee-capsules.ninjasforjava.com/rest'
}


